const state = {
	cartItemList: [],
	serviceFlag: false,
}

const mutations = {
	'UPDATE_CART' (state, {item, price, discount, quantity, isAdd}) {
		if (item.type && (item.type=='ServiceIn' || item.type=='ServiceOut')){
			state.serviceFlag = true
		}
		const record = state.cartItemList.find(element => element.name == item.name);
		if (record) {
			record.price = price
			record.discount = discount
			if (isAdd) {
				record.quantity += quantity
			} else {
				record.quantity = quantity
			}
		} else {
			state.cartItemList.push({
				...item,
				price,
				discount,
				quantity,
			});
		}
	},
	'SET_CART' (state, productList) {
		if (productList) {
			state.cartItemList = productList;
			if (productList==[])
				state.serviceFlag = false
		}
	},
	'REMOVE_CART_ITEM' (state, {item}) {
		const record = state.cartItemList.find(element => element.name == item.name);
		state.cartItemList.splice(state.cartItemList.indexOf(record), 1);
		if (state.cartItemList.length==0)
			state.serviceFlag = false
	},
	'SET_SERVICE_FLAG' (state, serviceFlag){
		state.serviceFlag = serviceFlag
	}
}

const actions = {
	clearCart: ({commit}) => {
		commit('SET_CART', []);
		commit('SET_SERVICE_FLAG', false);
	},
	setCart: ({commit}, cartObj) => {
		commit('SET_CART', cartObj);
	}
}

const getters = {
	cartItemList: (state) => {
		return state.cartItemList;
	},
	serviceFlag: (state) => {
		return state.serviceFlag;
	},
	cartValue: (state) => {
		let res = 0;
		state.cartItemList.map(item => {
			res += (item.price - item.discount) * item.quantity
		});
		return Number(res.toFixed(2))
	},
	taxValue: (state) => {
		let res = 0;
		state.cartItemList.map(item => {
			console.log(item.taxrate)
			res += (item.price - item.discount) * item.quantity * item.taxrate/100
		});
		return Number(res.toFixed(2))
	},
	totalValue: (state) => {
		let res = 0;
		state.cartItemList.map(item => {
			res += (item.price - item.discount) * item.quantity * (1 + item.taxrate/100)
		});
		return Number(res.toFixed(2))
	},
}

export default {
	state,
	mutations,
	actions,
	getters
}
